<template>
  <div class="items-grid-container">
    <items-grid
      :items="elements"
      :title="title"
      :can-upload="isManager && currentFolder && currentFolder.pk > 0 || isOwner"
      :can-hover="canHover()"
      :current-folder="currentFolder"
      :count="count"
      :loading="loading"
      @search="onSearch"
      @upload-clicked="onUploadClicked"
      @delete="onDeleteItem"
      @reached-bottom="loadMore"
      @selected-image="onSelectedImage"
      @share-clicked="onShareClicked"
    />
    <upload-collateral-modal
      v-model="modal"
      :uploading="uploading"
      :count="nUploaded"
      @upload="onUpload"
    />
    <items-zoom-modal
      v-if="imageIndex >= 0"
      v-model="imageIndex"
      :count="count"
      :next-page-exists="nextPageExists"
      :loading="loading"
      @reached-bottom="loadMore"
    />
    <collateral-share-modal
      :show="showShareModal"
      :folder="currentFolder"
      @closed="onShareModalClosed"
      @click="onShareModalClicked"
    />
  </div>
</template>
<script>

import _ from 'lodash';
import api from '@/_api';
import Listable from '@/components/mixins/listable';
import ItemsZoomModal from './ItemsZoomModal';
import ItemsGrid from './ItemsGrid';
import UploadCollateralModal from './UploadCollateralModal';

export default {
  name: 'ItemsGridContainerV2',
  components: {
    ItemsGrid,
    UploadCollateralModal,
    ItemsZoomModal,
  },
  mixins: [Listable],
  props: {
    mode: {
      type: String,
      default: 'loadMore',
    },
    source: {
      type: String,
      default: 'collateral',
    },
    pageSize: {
      type: Number,
      default: 40,
    },
  },
  data() {
    return {
      modal: false,
      imageModal: false,
      uploading: false,
      nUploaded: 0,
      imageIndex: -1,
      showShareModal: false,
    };
  },
  computed: {
    title() {
      return (this.search && this.search.length) ? `Search results (${this.elements.length})` : this.currentFolder.name;
    },
    currentFolder() {
      return this.$store.state.folders.item;
    },
    isManager() {
      return this.$store.state.account.user.profile.role.includes('manager');
    },
    currentUserPk() {
      return this.$store.state.account.user.profile.pk;
    },
    count() {
      return this.$store.state.collateral.count;
    },
    currentFolderPk() {
      return this.$route.params.folderId;
    },
    fetchRoute() {
      return this.currentFolderPk === 'shared' ? `${this.source}/getSharedCollages` : Listable.computed.fetchRoute.call(this);
    },
    loading() {
      return this.$store.state.collateral.isLoading;
    },
    isOwner() {
      return this.$store.state.account.user.profile.url === this.currentFolder.owner;
    },
  },
  watch: {
    currentFolderPk(newval) {
      this.truePage = 1;
      this.hasFolderParam(newval);
      this.reset();
      this.fetchData();
    },
  },
  beforeMount() {
    if (this.currentFolderPk) {
      this.queryParams.folder = this.currentFolderPk;
    }
  },
  methods: {
    onSelectedImage(index) {
      this.imageIndex = index;
    },
    onShareClicked() {
      this.showShareModal = true;
    },
    onShareModalClosed() {
      this.showShareModal = false;
    },
    onShareModalClicked() {
      this.showShareModal = false;
    },
    hasFolderParam(pkValue) {
      if (!pkValue && this.queryParams.folder) {
        delete this.queryParams.folder;
      } else if (pkValue) {
        this.queryParams.folder = pkValue;
      }
    },
    onSearch: _.debounce(function (evt) {
      this.search = evt;
    }, 200),
    onUploadClicked() {
      this.modal = true;
    },
    onUpload(files) {
      // Post new collaterals
      console.log('On Upload1');
      if (this.currentFolder.pk < 0) {
        console.warn('Tried to upload to "ALL"');
        return;
      }
      if (this.uploading) {
        console.warn('Tried to upload while already uploading');
        return;
      }
      let finished = 0;
      this.nUploaded = 0;
      this.uploading = true;
      files.forEach((file) => {
        const formData = new FormData();
        formData.append('image', file);
        formData.append('folder', this.currentFolder.pk >= 0 ? this.currentFolder.url : null);
        api.post('/collateral/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(() => {
          this.nUploaded = this.nUploaded + 1;
        }).catch((error) => {
          console.error('Upload failure: ', error.response && error.response.status ? error.response.status : '?');
        }).finally(() => {
          finished += 1;
          if (finished === files.length) {
            this.uploading = false;
            this.modal = false;
            this.refreshFolders();

            // Trigger notification
            api.post(`/collateral-notification/${this.currentFolder.pk}/`);

            // Show toast
            /* if (this.nUploaded === files.length) EventBus.$emit('toast', `Uploaded ${this.nUploaded} items`)
            else if (this.nUpload > 0) EventBus.$emit('toast', `Uploaded ${this.nUploaded} items with ${files.length - this.nUploaded} errors`)
            else EventBus.$emit('toast-error', 'Failed to upload! Please retry') */
          }
        });
      });
    },
    refreshFolders() {
      this.$store.dispatch('folders/getAll');
      if (this.currentFolder.pk >= 0) this.$store.dispatch('folders/getItem', this.currentFolder.pk);
      this.reset();
      this.fetchData();
    },
    onDeleteItem(itemPk) {
      if (this.currentFolder.shared) {
        this.$store.dispatch('collateral/hideSharedCollage', itemPk);
        return;
      }
      this.hasFolderParam(this.currentFolderPk);
      this.queryParams.id = itemPk;
      this.$store.dispatch('collateral/deleteItemWithoutAll', this.queryParams);
    },
    canHover() {
      return (item) => (this.isManager
        || (this.currentFolder.shared && item.uploaderPk === this.currentUserPk)
        || this.isOwner);
    },
  },
};
</script>
<style lang="scss" scoped>
.items-grid-container {
  height: 100%;
}
</style>
